import React from "react";
import IconButtonAtm from "../../../../atoms/IconButtonAtm";
var CtaIcon = function CtaIcon(_ref) {
  var icon = _ref.icon,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(IconButtonAtm, {
    icon: icon,
    sizeSpace: 1.5,
    onClick: onClick
  });
};
export default CtaIcon;